import { useEffect } from "react";

/**
 * @param {(element: HTMLIFrameElement) => void} handler 
 */
export default function useExternalClickHandler(handler) {
    useEffect(() => {
        window.focus();
    }, []);

    useEffect(() => {
        window.addEventListener("blur", onBlur);
        return () => window.removeEventListener("blur", onBlur);
    }, [handler]);

    function onBlur(e) {
        e.stopImmediatePropagation();
        setTimeout(() => {
            if (document.activeElement.tagName === "IFRAME") {
                handler(document.activeElement);
                setTimeout(window.focus, 100);
            }
        });
    }
}